import React, {Component} from 'react';
import { connect } from 'react-redux';

class FilterButton extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selected: this.props.selected ? this.props.selected : false
        };

        this.selectDeselectFilter = this.selectDeselectFilter.bind(this);
    }

    selectDeselectFilter = () => {
        if(this.state.selected) {
            this.setState({
                selected: false
            })
        } else {
            this.setState({
                selected: true
            })
        }

        return this.props.handleInteractivity ? this.props.handleInteractivity() : '';
    };


    render() {
        if(this.props.appearance === 'styled') {
            return (
                    <div key={this.props.key} onClick={ this.props.interactivity ? this.selectDeselectFilter : null } className={`filter-button ${this.state.selected ? 'selected' : '' }` }>
                        <input type='checkbox' name='genderFilter' checked={!!this.state.selected} onChange={ this.props.interactivity ? this.selectDeselectFilter : null }/>
                        { this.props.label }
                    </div>
            );
        } else {
            return (
                <div className="normal-checkbox" key={this.props.key}>
                    <input type='checkbox' name='cinemaFilter' onChange={this.props.handleInteractivity} checked={this.props.selectedValue === this.props.identifier ? true : false}/>
                    <label onClick={ this.props.interactivity ? this.selectDeselectFilter : null } className="checkbox-label" htmlFor="cinemaFilter" />
                    <span>{ this.props.label }</span>
                </div>
            )
        }
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(FilterButton);



// WEBPACK FOOTER //
// ./src/SHARED/components/filterbutton/filterbutton.component.js